export default __webpack_public_path__ + "static/media/line2.373ad6bc.svg";